import { logAndylitics, log, logAPI } from "./andyliticsApi";
import * as Tools from "../helpers/Tools";

const healthPlanApiUrl = typeof window !== 'undefined' ? window.serverData.data.healthPlanApiUrl : ''; // window is undefined during pre-render
const apiBaseUrl = typeof window !== 'undefined' ? window.serverData.data.apiBaseUrl : "";

export const getHealthPlanData = (token) => {      
    const url = encodeURI( Tools.buildUrl( healthPlanApiUrl, '/api/v1/HealthSource/HealthPlan/SummaryEx'));    
    const params = {
        method: 'get',
        headers: {
            'Authorization': 'bearer ' + token
        }
    };
    var start = new Date();
    return fetch(url, params).then(response => {    
        logAPI("MBHWeb.Api.HealthPlan.GetPlanData", start, url);
        if (response && response.status && response.status >= 200 && response.status < 300) {            
            return Promise.resolve(response.json());
        } else {                      
            return Promise.reject(response);
        }
    }).catch(err => { logAPI("MBHWeb.Api.HealthPlan.GetPlanData.Failure", start, url, err); return Promise.reject(err); });
};

export const getHealthPlans = (token) => {
    const url = encodeURI(Tools.buildUrl(apiBaseUrl, `/v1/healthsource/app/GetHealthPlans`));
    const start = new Date();
    const params = {
        method: "POST",
        headers: {
            "Authorization": 'bearer ' + token,
            "Accept": "application/json",
            "Content-type": "application/json"
        },
    };
    return fetch(url, params).then(response => {
        if (response.status === 200) {
            logAPI("MBHWeb.Api.GetHealthPlans", start, url);
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => { logAPI("MBHWeb.Api.GetHealthPlans.Failure", start, url, err); return Promise.reject(err); });
};

export const getHealthPlanTileData = (token, loginId, healthPlanName) => {
    const url = encodeURI(Tools.buildUrl(apiBaseUrl, `/v3/HealthPlan/GetHealthPlanDashboardData?loginid=${loginId}`));
    const params = {
        method: 'get',
        headers: {
            'Authorization': 'bearer ' + token
        }
    };
    const start = new Date();

    return fetch(url, params).then(response => {
        logAPI(`MBHWeb.Api.${healthPlanName}.DataTile`, start, url);
        if (response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI(`MBHWeb.Api.${healthPlanName}.DataTile.Failure`, start, url, err); return Promise.reject(err); });
};

export const linkAutoHPAccount = (token, memberId, username, loginProvider, userRole) => {
    const url = encodeURI(Tools.buildUrl(apiBaseUrl, `/v2/HealthSource/Registration/ValidateAutoLinkedAccount`));
    const start = new Date();
    const data = { username: username, providerKey: memberId, loginProvider: loginProvider };
    const userCurrentRole = userRole ? userRole : "SWHP";
    const params = {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            "Authorization": 'bearer ' + token,
            "Accept": "application/json",
            "Content-type": "application/json"
        }
    };
    return fetch(url, params).then(response => {
        logAPI(`MBHWeb.Api.${userCurrentRole}.AutoLink`, start, url);
        return response;
    }).catch(err => { logAPI(`MBHWeb.Api.${userCurrentRole}.AutoLink.Failure`, start, url, err); return Promise.reject(err); });
};

export const linkHPAccount = (token, memberId, username, dob, ssn) => {
    const url = encodeURI(Tools.buildUrl(apiBaseUrl, `/v3/HealthSource/Registration/LinkHealthPlanAccount`));
    const start = new Date(); 
    const data = { username: username, memberId: memberId, dob: dob, ssn : ssn };
    const params = {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            "Authorization": 'bearer ' + token,
            "Accept": "application/json",
            "Content-type": "application/json"
        }
    };
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.SWHP.Link", start, url);
        if (response && response.status && response.status === 200) {
            return Promise.resolve(response.json());
        }
        else return response.json();
    }).catch(err => { logAPI("MBHWeb.Api.SWHP.Link.Failure", start, url, err); return Promise.reject(err); });
};

export const unLinkHPAccount = (token, memberId, username) => {
    const url = encodeURI(Tools.buildUrl(apiBaseUrl, `/v3/HealthSource/Registration/UnlinkHealthPlan`));
    const start = new Date();
    const data = { username: username, memberid: memberId };
    const params = {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            "Authorization": 'bearer ' + token,
            "Accept": "application/json",
            "Content-type": "application/json"
        },
    };
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.SWHP.UnLink", start, url);
        if (response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        }
        else return response.json();
    }).catch(err => { logAPI("MBHWeb.Api.SWHP.UnLink.Failure", start, url, err); return Promise.reject(err); });
};

export const linkAAAccount = (token, memberId, username, dob, ssn) => {
    const url = encodeURI( Tools.buildUrl( apiBaseUrl, `/v3/HealthSource/Registration/LinkAAL`));
    const start = new Date(); 
    const data = { username: username, memberId: memberId, dob: dob, ssn : ssn };
    const params = {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            "Authorization": 'bearer ' + token,
            "Accept": "application/json",
            "Content-type": "application/json"
        }
    };
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.AA.Link", start, url);
        if (response && response.status && response.status === 200) {
            return Promise.resolve(response.json());
        }
        else return response.json();
    }).catch(err => { logAPI("MBHWeb.Api.AA.Link.Failure", start, url, err); return Promise.reject(err); });
};

export const unLinkAAAccount = (token, memberId, username) => {
    const url = encodeURI(Tools.buildUrl(apiBaseUrl, `/v3/HealthSource/Registration/UnlinkAAL`));
    const start = new Date();
    const data = { username: username, memberid: memberId };
    const params = {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            "Authorization": 'bearer ' + token,
            "Accept": "application/json",
            "Content-type": "application/json"
        },
    };
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.AA.UnLink", start, url);
        if (response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        }
        else return response.json();
    }).catch(err => { logAPI("MBHWeb.Api.AA.UnLink.Failure", start, url, err); return Promise.reject(err); });
};

export const linkFirstCareAccount = (token, username, dob, memberId) => {
    const url = encodeURI(Tools.buildUrl(apiBaseUrl, `/v3/HealthSource/Registration/LinkHealthRulesFC`));
    const start = new Date();
    const data = { username, memberId, dob };
    const params = {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            "Authorization": 'bearer ' + token,
            "Accept": "application/json",
            "Content-type": "application/json"
        }
    };
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.FirstCare.Link", start, url);
        if (response && response.status && response.status === 200) {
            return Promise.resolve(response.json());
        }
        else return response.json();
    }).catch(err => { logAPI("MBHWeb.Api.FirstCare.Link.Failure", start, url, err); return Promise.reject(err); });
};

export const unlinkFirstCareAccount = (token, username, memberId ) => {
    const url = encodeURI(Tools.buildUrl(apiBaseUrl, `/v3/HealthSource/Registration/UnlinkHealthRulesFC`));
    const start = new Date();
    const data = { username, memberId };
    const params = {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            "Authorization": 'bearer ' + token,
            "Accept": "application/json",
            "Content-type": "application/json"
        },
    };
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.FirstCare.UnLink", start, url);
        if (response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        }
        else return response.json();
    }).catch(err => { logAPI("MBHWeb.Api.FirstCare.UnLink.Failure", start, url, err); return Promise.reject(err); });
};

export const linkDartAccount = (token, username, dob) => {
    const url = encodeURI(Tools.buildUrl(apiBaseUrl, '/v3/HealthSource/Registration/LinkDART'));
    const start = new Date();
    const data = { username, dob };
    const params = {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            "Authorization": 'bearer ' + token,
            "Accept": "application/json",
            "Content-type": "application/json"
        },
        mode: "no-cors"
    };
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.Dart.Link", start, url);
        if (response && response.status && response.status === 200) {
            return Promise.resolve(response.json());
        }
        else return response.json();
    }).catch(err => { logAPI("MBHWeb.Api.Dart.Link.Failure", start, url, err); return Promise.reject(err); });
};

export const unlinkDartAccount = (token, username) => {
    const url = encodeURI(Tools.buildUrl(apiBaseUrl, `/v3/HealthSource/Registration/UnlinkDART`));
    const start = new Date();
    const data = { username };
    const params = {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            "Authorization": 'bearer ' + token,
            "Accept": "application/json",
            "Content-type": "application/json"
        },
    };
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.Dart.UnLink", start, url);
        if (response && response.status && response.status === 200) {
            return Promise.resolve(response.json());
        }
        else return response.json();
    }).catch(err => { logAPI("MBHWeb.Api.Dart.UnLink.Failure", start, url, err); return Promise.reject(err); });
}

export const linkWACOAccount = (token, username, dob) => {
    const url = encodeURI(Tools.buildUrl(apiBaseUrl, '/v3/HealthSource/Registration/LinkWACO'));
    const start = new Date();
    const data = { username, dob };
    const params = {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            "Authorization": 'bearer ' + token,
            "Accept": "application/json",
            "Content-type": "application/json"
        },
        mode: "no-cors"
    };
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.Waco.Link", start, url);
        if (response && response.status && response.status === 200) {
            return Promise.resolve(response.json());
        }
        else return response.json();
    }).catch(err => { logAPI("MBHWeb.Api.WACO.Link.Failure", start, url, err); return Promise.reject(err); });
};

export const unlinkWacoAccount = (token, username) => {
    const url = encodeURI(Tools.buildUrl(apiBaseUrl, `/v3/HealthSource/Registration/UnlinkWACO`));
    const start = new Date();
    const data = { username };
    const params = {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            "Authorization": 'bearer ' + token,
            "Accept": "application/json",
            "Content-type": "application/json"
        },
    };
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.Waco.UnLink", start, url);
        if (response && response.status && response.status === 200) {
            return Promise.resolve(response.json());
        }
        else return response.json();
    }).catch(err => { logAPI("MBHWeb.Api.Waco.UnLink.Failure", start, url, err); return Promise.reject(err); });
}